import { NgForm, FormsModule } from '@angular/forms';
import {GenerateFormControlService} from '../../../modules/dossiers/field-generator/generate-form-control.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { AfterViewInit, Component, inject } from '@angular/core';
import {Publication} from '../../../class/api/Publication';
import {ToolsService} from '../../services/tools/tools.service';
import {HydraService} from '../../../core/services/hydra.service';
import {PublicationType} from '../../../class/api/PublicationType';
import {api} from '../../../api/api-dictionnary';
import {HydraCollection} from '../../../class/generic/hydra-collection';
import {TranslationService} from '../../services/translation.service';
import {AuthentificationService} from '../../../core/services/authentification.service';
import {QUILL_DOSSIER_CONFIG} from "../../../core/consts/quill";

import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { StrictNumberOnlyDirective } from '../../directives/strictNumberOnly';
import { MatButton } from '@angular/material/button';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { NumberOnlyDirective } from '../../directives/numericNumberOnly';
import { QuillModule } from 'ngx-quill';
import { FileUploaderComponent } from '../file-uploader/file-uploader.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-modal-publication-add-edit',
    templateUrl: './modal-publication-add-edit.component.html',
    styleUrls: ['./modal-publication-add-edit.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatFormField, MatLabel, MatInput, FormsModule, StrictNumberOnlyDirective, MatButton, MatDialogActions, MatSelect, MatOption, NumberOnlyDirective, QuillModule, FileUploaderComponent, TranslateModule]
})
export class ModalPublicationAddEditComponent implements AfterViewInit {
    dialogRef = inject<MatDialogRef<ModalPublicationAddEditComponent>>(MatDialogRef);
    data = inject<{
    publication: any;
    pmidList: [
    ];
    showStatutSoumis: boolean;
    showStatutEnPreparation: boolean;
}>(MAT_DIALOG_DATA);
    toolService = inject(ToolsService);
    generateFormControlService = inject(GenerateFormControlService);
    hydraService = inject(HydraService);
    auth = inject(AuthentificationService);
    translationService = inject(TranslationService);

    publication: Publication = new Publication();

    pmidList: number[] = [];
    public modules = this.toolService.deepCloneQuill(QUILL_DOSSIER_CONFIG);

    saisieActivee = false;
    public publicationTypeList: PublicationType[] = [];

    STATUT_PUBLIE = 1;
    STATUT_SOUS_PRESSE = 2;
    STATUT_REVISION = 3;
    STATUT_SOUMIS = 4;
    STATUT_EN_PREPARATION = 5;

    showStatutSoumis = false;
    showStatutEnPreparation = false;


    constructor() {


        if (this.data.publication != undefined) {
            this.publication = {...this.data.publication};

            if (this.publication.id == null) {
                delete this.publication.position;
            } else {
                this.saisieActivee = true;
            }
        }

        this.showStatutSoumis = this.data.showStatutSoumis;
        this.showStatutEnPreparation = this.data.showStatutEnPreparation;

        if (this.data.pmidList) {
            this.pmidList = this.data.pmidList;
        }

        this.hydraService
            .getList(api.publicationType + '?enabled=true')
            .subscribe((res: HydraCollection) => {
                this.publicationTypeList = res.getMember();
            });

        if(this.auth.userConnected.locale !== 'fr') {
            this.modules['counter'].unit = 'character';
        }
        this.modules['counter'].container = '#modal-pub-counter';
    }

    public save() {
        if (this.publication.statut === 1) {
            this.removeCurrentFile();
        }
        console.log(this.publication);
        this.dialogRef.close(this.publication);
    }

    cancelModal() {
        this.dialogRef.close(false);
    }

    public currentFiledSaved(event) {
        this.publication.fichier = event[0];
    }

    public removeCurrentFile() {
        this.publication.fichier = null;
    }

    public pageLoaded = false;
    isBusy = false;

    ngAfterViewInit() {
        setTimeout(() => {
            this.pageLoaded = true;
        });
    }

    public buttonDisabled(formGroup: NgForm) {
        if (!this.pageLoaded) {
            return false;
        }

        //si annee incorrecte
        if (this.publication.statut == 1 && (isNaN(this.publication.annee) || this.publication.annee < 1903 || this.publication.annee > 2100)) {
            return true;
        }

        //si pmid incorrect
        if (this.publication.pmid && (isNaN(this.publication.pmid) || !this.matchNumber(this.publication.pmid))) {
            return true;
        }

        // Si pas de fichier et statut spécifique alors form Submit Disable
        if ([this.STATUT_SOUS_PRESSE, this.STATUT_REVISION].includes(this.publication.statut) && [null, undefined].includes(this.publication.fichier)) {
            return true;
        }

        if (this.isPmidUsed()) {
            return true;
        }

        //Si pas de statut conditionnel mais que form Invalid alors disable
        return formGroup.invalid;
    }

    matchNumber(pmid) {
        return pmid.toString().match(/^[0-9]*$/);
    }

    searchOnPubMed() {
        const pmid = +this.publication.pmid;

        if (this.pmidList.includes(pmid)) {
            return;
        }

        if (!pmid) {
            return;
        }

        this.isBusy = true;
        this.hydraService.getItem('/api/pub_med_publications/' + pmid).subscribe(
            (res: {
                pmid: string;
                doi: string;
                title: string;
                publicationYear: number;
                authors: string[];
                publicationTypes: string[];
                journal: string;
            }) => {
                this.isBusy = false;

                this.publication = new Publication(
                    {
                        ...this.publication,
                        statut: 1,
                        pmid: Number(res.pmid),
                        titre: res.title,
                        auteurs: res.authors.join(', '),
                        annee: res.publicationYear,
                        journal: res.journal,
                        doi: res.doi
                    }
                );
                this.saisieActivee = true;
            },
            () => {
                this.toolService.notificationError(
                    'Impossible de retrouver la publication / Unable to find publication',
                    5000
                );
                this.isBusy = false;
            }
        );
    }

    isPmidUsed() {
        if (this.data.pmidList === null) {
            return false;
        }
        let list: number[] = [];
        if (this.data.publication && this.data.publication.pmid) {
            list = this.data.pmidList.filter(pmid => pmid !== +this.data.publication.pmid);
        } else {
            list = this.data.pmidList;
        }
        return list.includes(+this.publication.pmid);
    }
}
